import * as React from 'react';
import { AuthConsumer } from 'containers';

export const ShowIfLoggedIn = (children) => (
	<AuthConsumer>
		{({ isAuthenticated }) => {
			if (isAuthenticated()) {
				return children;
			}
		}}
	</AuthConsumer>
);
